module.exports = __webpack_public_path__ + "assets/img/ZT599NM-M.cf23a39d.png";